import script from "./PortfolioDetailsQualities.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDetailsQualities.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDetailsQualities.vue?vue&type=style&index=0&id=f82bd232&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82bd232"]])

export default __exports__